import { createInstance } from '@optimizely/react-sdk';
import { v4 as uuidv4 } from 'uuid';

const OPTIMIZELY_USER_ID_STORAGE_KEY = 'clientId';

const OptimizelyConstants = {
  EVENTS: {
    SIGNUP_CLICKED: "Signup Clicked",
    SIGNUP_SUCCESS: "Signup Success",
  },
  OUTCOMES: {
    SUCCESS: "success",
    FAILED_VALIDATION: "failed-validation",
  }
}

const initializeOptimizely = optimizelySettings => {
  if (!optimizelySettings || !optimizelySettings.datafile) {
    return [null, null];
  }
  // Only enable Optimizely if we can store client-side user identifier
  if (typeof window !== 'undefined' && window.localStorage) {
    const instance = createInstance({
      datafile: optimizelySettings.datafile
    });
    let userId = window.localStorage.getItem(OPTIMIZELY_USER_ID_STORAGE_KEY);
    if (!userId) {
      userId = uuidv4();
      window.localStorage.setItem(OPTIMIZELY_USER_ID_STORAGE_KEY, userId);
    }
    return [instance, userId];
  }
  return [null, null];
};

const trackOptimizelyEvent = (instance, userId, eventType, eventOutcome = OptimizelyConstants.OUTCOMES.SUCCESS, eventAttributes = {}) => {
  eventAttributes = {...eventAttributes, eventOutcome};
  instance.track(eventType, userId, eventAttributes);
}

export { OptimizelyConstants, initializeOptimizely, trackOptimizelyEvent };
